import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Icon, RequestCard } from '@/ds'
import { useAppNavigate, withQuery } from '@/lib/query-params'
import { useAsync } from '@/lib/useAsync'
import { featureEnabled } from '@/config/features'
import { peticionesService } from '@/services/peticiones'
import type { Stay } from '@/services/reserva'
import { HELP_ROUTES, requestMeta, requestTitle } from '../../Ayuda/shared'

/**
 * Petición en curso en la fase "durante" (Inicio.dc.html phase=during): la más reciente sin resolver, con el enlace a
 * Ayuda. Sin peticiones en la API (D48), sin datos o con error no se muestra nada: la fila de Ayuda sigue abajo.
 */
export function RequestSection({ stay }: { stay: Stay }) {
  if (!featureEnabled('ayudaPeticiones')) return null
  return <RequestSectionContent stay={stay} />
}

function RequestSectionContent({ stay }: { stay: Stay }) {
  const { t, i18n } = useTranslation()
  const { go, search } = useAppNavigate()
  const [now] = useState(() => new Date())
  const [data] = useAsync(`estancia-peticiones:${stay.guestCode}`, (signal) => peticionesService.list(stay, signal))
  if (data.kind !== 'ready') return null
  const open = data.value.filter((r) => r.status !== 'resolved' && r.type !== 'booking_change').sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0]
  if (!open) return null
  return (
    <Card>
      <RequestCard title={requestTitle(open, t)} status={open.status} date={requestMeta(open, now, i18n.language, t)} onClick={() => go(HELP_ROUTES.request(open.id))} />
      <a
        href={withQuery(HELP_ROUTES.home, search)}
        className="pagos__chevron-link"
        onClick={(e) => {
          e.preventDefault()
          go(HELP_ROUTES.home)
        }}
      >
        {t('v2.peticiones.estancia.ver')}
        <Icon name="chevron-right" size={20} />
      </a>
    </Card>
  )
}
